import { Loader } from '@getro/rombo';
import React, { useEffect } from 'react';
import { Flex } from 'rebass/styled-components';

import { useSignOut } from '../../hooks/useSignOut';

export const LogOut = () => {
  const { signOut } = useSignOut();

  useEffect(() => {
    signOut();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Flex height="100vh" alignItems="center">
      <Loader />
    </Flex>
  );
};
